import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface BodyProps {
  children?: ReactNode;
  className?: string;
}

export const Body = ({ className, children }: BodyProps) => (
  <div className="main">
    <div className={classNames("main__wrapper", className)}>{children}</div>
  </div>
);
